import { useGetMeasurements } from "hooks/Measurement/useGetMeasurements";
import { CreateProductType } from "../../types";
import EditSubmitButton from "../EditComponents/EditSubmitButton";
import { Dropdown, MenuProps } from "antd";
import { Icon } from "@iconify-icon/react";

const ShippingAndInventoryForm = ({
  setActive,
  active,
  handleInputChange,
  payload,
  setPayload,
  edit,
  handleSubmit,
  validity,
  isLoading,
}: {
  active: number;
  setActive: any;
  handleInputChange: any;
  payload: CreateProductType;
  edit?: boolean;
  handleSubmit: any;
  setPayload: any;
  validity: any;
  isLoading: any;
}) => {
  const { data: measurements } = useGetMeasurements();

  const itemTwo: MenuProps["items"] =
    measurements?.data?.flatMap((measurement: any, index: any) => [
      {
        label: measurement.label,
        key: String(index),
        onClick: () =>
          setPayload((prevState: any) => ({
            ...prevState,
            unitStockMeasurement: measurement.label,
          })),
      },
      { type: "divider" },
    ]) || [];

  const bulkItem: MenuProps["items"] =
    measurements?.data?.flatMap((measurement: any, index: any) => [
      {
        label: measurement.label,
        key: String(index),
        onClick: () =>
          setPayload((prevState: any) => ({
            ...prevState,
            bulkStockMeasurement: measurement.label,
          })),
      },
      { type: "divider" },
    ]) || [];

  return (
    <div className="mx-auto max-w-[700px] border-[1px] border-[#eeeeee] rounded-[10px] mt-[20px]">
      <div className="p-[20px] font-medium border-b-[1px] border-[#eeeeee]">
        Stock Measurement
      </div>
      <div className="p-[20px]">
        <div className="flex gap-2">
          <div className="w-4/12">
            <label
              htmlFor="unitStockMeasurement"
              className="mt-[30px] text-grey"
            >
              Unit Measurement
            </label>

            <Dropdown menu={{ items: itemTwo }} trigger={["click"]}>
              <div
                onClick={(e) => e.preventDefault()}
                className="mt-2 p-3 mb-3 text-[16px] bg-white w-full flex justify-between items-center border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              >
                {payload?.unitStockMeasurement || "Select Unit"}
                <Icon
                  icon="iconamoon:arrow-down-2-duotone"
                  width={20}
                  color="#474747"
                />
              </div>
            </Dropdown>
          </div>
          <div className="w-4/12">
            <label htmlFor="unitWeight" className="mt-[30px] text-grey">
              Unit Weight
            </label>
            <input
              name="unitWeight"
              type="text"
              value={payload?.unitWeight}
              onChange={handleInputChange}
              placeholder="50g"
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
          <div className="w-4/12">
            <label htmlFor="unitPrice" className="mt-[30px] text-grey">
              Unit Price
            </label>
            <input
              name="unitPrice"
              type="text"
              value={payload?.unitPrice}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-4/12">
            <label
              htmlFor="unitStockMeasurement"
              className="mt-[30px] text-grey"
            >
              Bulk Measurement
            </label>
            <Dropdown menu={{ items: bulkItem }} trigger={["click"]}>
              <div
                onClick={(e) => e.preventDefault()}
                className="mt-2 p-3 mb-3 text-[16px] bg-white w-full flex justify-between items-center border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              >
                {payload?.bulkStockMeasurement || "Select Unit"}
                <Icon
                  icon="iconamoon:arrow-down-2-duotone"
                  width={20}
                  color="#474747"
                />
              </div>
            </Dropdown>
          </div>
          <div className="w-4/12">
            <label htmlFor="bulkWeight" className="mt-[30px] text-grey">
              Bulk Weight
            </label>
            <input
              name="bulkWeight"
              type="text"
              value={payload?.bulkWeight}
              onChange={handleInputChange}
              placeholder="25kg"
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
          <div className="w-4/12">
            <label htmlFor="bulkPrice" className="mt-[30px] text-grey">
              Bulk Price
            </label>
            <input
              name="bulkPrice"
              type="text"
              value={payload?.bulkPrice}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <label
              htmlFor="bulkShippingMinQtyBetty"
              className="mt-[30px] text-grey"
            >
              Betty Min. Bulk Shipping (Optional)
            </label>
            <input
              name="bulkShippingMinQtyBetty"
              type="text"
              value={payload?.bulkShippingMinQtyBetty}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
          <div className="w-6/12">
            <label
              htmlFor="bulkShippingMaxQtyBetty"
              className="mt-[30px] text-grey"
            >
              Betty Max. Bulk Shipping (Optional)
            </label>
            <input
              name="bulkShippingMaxQtyBetty"
              type="text"
              value={payload?.bulkShippingMaxQtyBetty}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <label
              htmlFor="bulkShippingMinQtyUber"
              className="mt-[30px] text-grey"
            >
              Uber Min. Bulk Shipping (Optional)
            </label>
            <input
              name="bulkShippingMinQtyUber"
              type="text"
              value={payload?.bulkShippingMinQtyUber}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
          <div className="w-6/12">
            <label
              htmlFor="bulkShippingMaxQtyUber"
              className="mt-[30px] text-grey"
            >
              Uber Max. Bulk Shipping (Optional)
            </label>
            <input
              name="bulkShippingMaxQtyUber"
              type="text"
              value={payload?.bulkShippingMaxQtyUber}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <label
              htmlFor="bulkShippingMinQtyWalkIn"
              className="mt-[30px] text-grey"
            >
              Walk in Min. Bulk Shipping (Optional)
            </label>
            <input
              name="bulkShippingMinQtyWalkIn"
              type="text"
              value={payload?.bulkShippingMinQtyWalkIn}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
          <div className="w-6/12">
            <label
              htmlFor="bulkShippingMaxQtyWalkIn"
              className="mt-[30px] text-grey"
            >
              Walk in Max. Bulk Shipping (Optional)
            </label>
            <input
              name="bulkShippingMaxQtyWalkIn"
              type="text"
              value={payload?.bulkShippingMaxQtyWalkIn}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <label htmlFor="lowUnitStock" className="mt-[30px] text-grey">
              Low Unit Stock (Optional)
            </label>
            <input
              name="lowUnitStock"
              type="text"
              value={payload?.lowUnitStock}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
          <div className="w-6/12">
            <label htmlFor="lowBulkStock" className="mt-[30px] text-grey">
              Low Bulk Stock (Optional)
            </label>
            <input
              name="lowBulkStock"
              type="text"
              value={payload?.lowBulkStock}
              onChange={handleInputChange}
              placeholder=""
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
        </div>
        <div className="flex gap-x-3">
          <div className="w-6/12">
            <button
              disabled={isLoading}
              className="text-orange bg-primary-light p-[16px] w-full font-bold rounded-md ease-in-out duration-300"
              onClick={() => setActive(active - 1)}
            >
              Previous
            </button>
          </div>
          <div className="w-6/12">
            <EditSubmitButton
              handleSubmit={handleSubmit}
              validity={validity}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingAndInventoryForm;
